<template>
    <div class="basic_wrap">
        <van-nav-bar
                safe-area-inset-top
                fixed
                :title="$t('lang.产品详情')"
                left-arrow
                @click-left="$router.back()"
        />
        <div class="box">
            <img class="logo" :src="data.img" alt="">

            

            <div class="info">
                <div class="font-main font-24">${{ data.max }}</div>
                <div class="flex">
                    <div class="font-sub font-15 card ml-8">
                      <img src="../../assets/img/user.png" alt="">
                      <span> <span class="font-main">VIP{{ data.user_member }}</span></span>
                  </div>
                </div>
            </div>
            <div class="info">
              <div class="font-main font-24">
                <div class="font-sub font-15 card">
                  <img src="../../assets/img/icon_time.png" alt="">
                  <span> {{ $t('lang.周期') }} <span class="font-main">{{ data.sy_ms == 1? data.hours : data.day }} {{ returnCy() }}</span></span>
              </div>
              </div>
              <div class="flex">
                <div class="font-sub font-15 card ml-8">
                  <img src="../../assets/img/icon_profit.png" alt="">
                  <span> {{ $t('lang.利率') }} <span class="font-main">{{ data.rate }} %</span></span>
              </div>
              </div>
          </div>

          <div class="info ">
            <div class="font-main font-15 title van-ellipsis">{{ data.title }}</div>
            <div class="font-main font-15 notice">{{ notice }}</div>
          </div>
            <div class="action">
                <div class="progress">
                    <van-progress :percentage="(data.used/data.num)*100" stroke-width="8" color="#be9f82"/>
                    <!--                    <div class="info1">{{ data.percent }}%</div>-->
                </div>
                <div class="btn-action">
                    <div class="font-sub font-10">{{ $t('lang.已购') }}/{{ $t('lang.限购') }} {{ data.used }}/{{ data.num }}</div>
                </div>
            </div>

            <div>
                <HomeRegion :title="$t('lang.详情')" :is-show-more="false">
                    <div class="font-main bg-tr" v-html="data.content"></div>
                </HomeRegion>
            </div>

            <div class="foot">
                <van-button type="primary" @click="buy" color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)" block>
                    {{ $t('lang.立即合作') }}
                </van-button>
            </div>

        </div>


        <cuDialog
                v-model="show_tz"
                @close="show_tz = !show_tz"
                :title="$t('lang.份额认领')"
                :confim-text="$t('lang.确认')"
                @confirm="confirm"
        >
            <div class="form-item">
                <span>{{ $t('lang.份额') }}</span>
                <span>{{ $t('lang.总量化金额') }} : ${{ amount }}</span>
            </div>
            <div class="form-item">
                <van-field v-model="number" type="number" @input="calcAmount" :placeholder="$t('lang.请输入份额')"/>
            </div>
        </cuDialog>

    </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from 'vue';
import {Progress, Dialog, Field} from 'vant';
import HomeRegion from '@/components/HomeRegion/index.vue';
import cuDialog from '@/components/Dialog/index.vue'

Vue.use(Progress).use(Dialog).use(Field);
export default {
    name: "itemDetail",
    components: {
        HomeRegion,
        cuDialog
    },
    data() {
        return {
            data: {
                percent: '0',
                max: '0',
                sy_ms: 0
            },
            show_tz: false,
            number: 1,
            amount: "",
        };
    },
    computed:{
        notice(){
            if( this.data.sy_ms === 0){
                return this.$t('lang.notice')
            }else if(this.data.sy_ms === 1){
                return this.$t('lang.notice1')
            }else if(this.data.sy_ms === 2){
                return this.$t('lang.notice2')
            }
        }
    },
    created() {
        this.$parent.footer('item', false);
    },
    mounted() {
        this.start();
    },
    methods: {
		returnCy(){
		    let msg = ''
		    let ms = this.data.sy_ms;
		    switch (ms) {
		        case 0:
		            msg = this.$t('utils.day')
		            break;
		        case 1:
		            msg = this.$t('lang.小时');
		            break;
		        case 2:
		            msg = this.$t('lang.天后结算');
		            break;
		        default:
		            break;
		    }
		    return msg;
		},
        calcAmount(){
          this.amount = (this.number * this.data.max).toFixed(2)
        },
        start() {
            Fetch('/index/item_detail', {
                id: this.$router.history.current.params.code
            }).then(res => {
				let info = res.data;
	            info.max = parseInt(info.max)
                this.data = info;
                this.calcAmount()
            })
        },
        buy() {
            this.show_tz = true;
        },
        confirm() {
            if (!this.number) {
                this.$toast(this.$t('lang.请输入投资份额'));
                return false;
            }
            Fetch("/index/item_apply", {
                id: this.data.id,
                num: this.number
            }).then(r => {
                this.$router.push("/order");
            }).catch(err => {
                this.number = '';
            })
        }
    }
};
</script>

<style lang="less" scoped>
.form-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding: 12px 2px;
  margin: 4px 0;
}

/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

.flex {
  display: flex;
}

.font-main {
  color: #eddcc9 !important;
}

.dialog {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
}

.bg-tr {
  padding-top: 20px;
  background: transparent !important;
}

.ml-8 {
  margin-left: 8px;
}

.font-sub {
  color: #87776a;
}

.font-24 {
  font-size: 24px;
}

.font-15 {
  font-size: 15px;
}

.font-10 {
  font-size: 13px;
}

.basic_wrap {
  padding-top: 46px;
  display: flex;
  height: 100vh;
  box-sizing: border-box;
  flex-direction: column;

  .box {
    flex: 1;
    background: url(../../assets/img/home-bg.jpg) no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: .3rem .3rem 80px .3rem;

    .foot {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 75px;
      box-sizing: border-box;
      padding: 10px;
      background: #191715;
      border-top: 0.0625rem solid #DEC5B0;
    }

    .logo {
      width: 100%;
      height: auto;
      border-radius: 12px;
    }

    .action {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      background: #3E2E21;
      padding: 10px 6px 10px 16px;
      border-radius: 10px;

      .btn-action {
        width: 100px;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;

        .btn {
          width: 80px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 10px;
          font-size: 14px;
          background: linear-gradient(0deg, rgba(182, 140, 115, 1) 0%, rgba(243, 226, 210, 1) 100%) !important;
        }
      }

      .progress {
        flex: 1;
        margin-top: 24px;
        margin-bottom: 16px;
        height: 12px;
        //background-color: #0a0c07;
        position: relative;

        .info1 {
          border-radius: 12px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          padding: 4px 6px;
          color: #FFFFFF;
          //background-color: #be9f82;
        }
      }
    }

    .info {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        max-width: 50%;
      }

      .notice {
        background: url("../../assets/img/tagBg.png") no-repeat;
        background-size: 100% 100%;
        height: 22px;
        line-height: 20px;
        padding: 2px 10px;
        color: #5a211b !important;
      }


      .card {
        height: 34px;
        padding: 0 6px;
        background: #09090D;
        border: 1px solid #443D3C;
        border-radius: 10px;
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}

/deep/ .van-cell {
  color: #eddcc9 !important;
  padding: 8px 3px;
  background: #0a0c07;
  border: 0.03rem solid rgb(205, 204, 202);
  border-radius: 6px;
}

/deep/ .van-field__control {
  color: #eddcc9;
}

/deep/ .van-button--default {
  background: #0a0c07;
}

.red_top_bg {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.back_left {
  background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
  left: 40px;
  width: 90%;
  color: #000000;
  transform: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item_img {
  margin: 45px 2% 0 2%;
  width: 96%;

  img {
    width: 100%;
  }
}

.items_3 {
  .item {

    div {
      //margin: 5px 0;
    }

    .item_div1 {
      display: flex;
      justify-content: space-between;
      background: #302A2A;
      padding: 15px 10px;

      p:nth-child(1) {
        // width: 90%;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_div2 {
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 14px;
      background: #0a0c07;

      div {
        width: 33.33%;

        p {
          padding: 5px 0;
        }
      }

      .item_rate {
        p:nth-child(1) {
          font-weight: bold;
          color: #FF0000;

        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_day {
        p:nth-child(1) {
          font-weight: bold;
        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_min {
        p:nth-child(1) {
          font-weight: bold;

        }

        p:nth-child(2) {
          color: #999;
        }
      }
    }

    .item_div3 {
      color: #999;
      padding: 5px 10px;
    }

    .item_div4 {
      padding: 5px 10px;

      div:nth-child(1) {
        width: 100%;
        margin-top: 16px;
        margin-bottom: 10px;
      }
    }

    .item_btn {
      width: 70%;
      position: absolute;
      bottom: 20px;
      margin-left: 15%;

      button {
        width: 100%;
        color: #1989fa;
        padding: 10px 5px;
        border-radius: 5px;
        border: 1px solid #1989fa;
        background: #FFFFFF;
      }

      .item_btn_over {
        color: #999;
        border: 1px solid #999;
      }
    }
  }

  .item_content {
    background: #FFFFFF;
    padding: 10px;
    line-height: 20px;
  }
}
</style>
